import React, { FC, PropsWithChildren } from "react";
import { BackdropStyle } from "./backdrop.style";

export const Backdrop: FC<PropsWithChildren> = (props) => {
    return <BackdropStyle>{props.children}</BackdropStyle>
};